import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'ur',
  months: ['جنوری', 'فروری', 'مارچ', 'اپریل', 'مئی', 'جون', 'جولائی', 'اگست', 'ستمبر', 'اکتوبر', 'نومبر', 'دسمبر'],
  monthsShort: ['جنوری', 'فروری', 'مارچ', 'اپریل', 'مئی', 'جون', 'جولائی', 'اگست', 'ستمبر', 'اکتوبر', 'نومبر', 'دسمبر'],
  weekdays: ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'],
  weekdaysMin: ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'],
  weekdaysShort: ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'YYYY/MM/DD',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY HH:mm',
    'LLL-Y': 'D MMMM HH:mm',
    LLLL: 'dddd، D MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd، D MMMM HH:mm',
    l: 'YYYY/M/D',
    'l-Y': 'M/D',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    lll: 'D MMM YYYY h:mm A',
    'lll-Y': 'D MMM h:mm A',
    llll: 'ddd، D MMM YYYY h:mm A',
    'llll-Y': 'ddd، D MMM h:mm A',
    'll-Y+w': 'ddd، D MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D MMMM، YYYY HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'صبح', pm: 'شام', AM: 'صبح', PM: 'شام' },
  past: {
    y: { one: '%s سال پہلے', other: '%s سال پہلے' },
    M: { one: '%s ماہ قبل', other: '%s ماہ قبل' },
    w: { one: '%s ہفتے پہلے', other: '%s ہفتے پہلے' },
    d: { one: '%s دن پہلے', other: '%s دن پہلے' },
    h: { one: '%s گھنٹے پہلے', other: '%s گھنٹے پہلے' },
    m: { one: '%s منٹ پہلے', other: '%s منٹ پہلے' },
    s: { one: '%s سیکنڈ پہلے', other: '%s سیکنڈ پہلے' },
  },
  future: {
    y: { one: '%s سال میں', other: '%s سال میں' },
    M: { one: '%s ماہ میں', other: '%s ماہ میں' },
    w: { one: '%s ہفتے میں', other: '%s ہفتے میں' },
    d: { one: '%s دن میں', other: '%s دنوں میں' },
    h: { one: '%s گھنٹے میں', other: '%s گھنٹے میں' },
    m: { one: '%s منٹ میں', other: '%s منٹ میں' },
    s: { one: '%s سیکنڈ میں', other: '%s سیکنڈ میں' },
  },
  abbr: {
    y: { one: '%s سال۔', other: '%s سال۔' },
    M: { one: '%s مہینہ', other: '%s مہینے' },
    w: { one: '%s ہفتہ', other: '%s ہفتے' },
    d: { one: '%s دن', other: '%s دن' },
    h: { one: '%s گھنٹہ', other: '%s گھنٹے' },
    m: { one: '%s منٹ', other: '%s منٹس' },
    s: { one: '%s سیکنڈ', other: '%s سیکنڈز' },
  },
  justNow: 'بالکل ابھی',
  yesterday: 'گزشتہ کل',
  today: 'آج',
  tomorrow: 'آنے والا کل',
  weekStart: 0,
};
const localeName: LocaleName = 'ur';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'صبح' : 'صبح';
    } else {
      return isLowerCase ? 'شام' : 'شام';
    }
  },
};
